import React from 'react';
import { useRouter } from 'expo-router';
import AcceptInvitationScreenEnhanced from '../../src/screens/auth/AcceptInvitationScreenEnhanced';
import { ROUTES } from '../../src/navigation/routes';

export default function AcceptInvitationRoute() {
  const router = useRouter();

  const handleSuccess = React.useCallback(() => {
    router.replace(ROUTES.PUBLIC_LOGIN);
  }, [router]);

  return <AcceptInvitationScreenEnhanced onAcceptSuccess={handleSuccess} />;
}
